import { MobileUserProfileModalComponent } from './../mobile-user-profile-modal/mobile-user-profile-modal.component';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { ProviderConnectionModal } from "./providerConnection.component";

export function ShowProviderConnectionModal(modalService: NgbModal, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = ProviderConnectionModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<ProviderConnectionModal>m.componentInstance);
  
    return modal;
}